
// noinspection JSUnusedGlobalSymbols

export const VAR_TYPE__INTEGER = 1;
export const VAR_TYPE__FLOAT = 2;
export const VAR_TYPE__TOKEN = 3;
export const VAR_TYPE__STRING = 4;
export const VAR_TYPE__VARIABLE = 6;
export const VAR_TYPE__COMMAND = 8;
export const VAR_TYPE__C1_STRING = 9;
export const VAR_TYPE__BYTE_STRING = 10;
export const VAR_TYPE__AGENT = 11;
export const VAR_TYPE__ANY = 13;
export const VAR_TYPE__CONDITION = 15;
export const VAR_TYPE__DECIMAL = 16;
export const VAR_TYPE__ANIMATION = 17;
export const VAR_TYPE__HEXADECIMAL = 18;
export const VAR_TYPE__PICT_DIMENSION = 19;